<template>
    <div v-if="shouldRender" class="yandex-pay-split-widget">
        <div v-if="isLoading" class="yandex-pay-split-widget__skeleton" aria-hidden="true" />
        <div
            ref="widgetContainer"
            class="yandex-pay-split-widget__mount"
            :class="{ 'yandex-pay-split-widget__mount--hidden': isLoading }"
        />
    </div>
</template>

<script>
import {
    buildYandexPayWidgetConfig,
    mountYandexPayInfoWidget,
    unmountYandexPayInfoWidget,
} from '../utilities'

export default {
    name: 'YandexPaySplitWidget',
    props: {
        amount: {
            type: Number,
            required: true,
        },
        currency: {
            type: String,
            default: 'RUB',
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        settings: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            shouldRender: false,
            isLoading: false,
        }
    },
    computed: {
        widgetConfig() {
            if (!this.enabled) {
                return null
            }

            const settings = this.settings || this.$store?.getters?.settings
            if (!settings) {
                return null
            }

            return buildYandexPayWidgetConfig(
                settings,
                this.amount,
                this.currency,
            )
        },
    },
    watch: {
        widgetConfig: {
            deep: true,
            handler() {
                this.refreshWidget()
            },
        },
    },
    mounted() {
        this.refreshWidget()
    },
    beforeUnmount() {
        this.destroyWidget()
    },
    methods: {
        async refreshWidget() {
            this.destroyWidget()

            const config = this.widgetConfig
            if (!config) {
                this.shouldRender = false
                this.isLoading = false
                return
            }

            this.shouldRender = true
            this.isLoading = true
            await this.$nextTick()

            const container = this.$refs.widgetContainer
            if (!container) {
                this.shouldRender = false
                this.isLoading = false
                return
            }

            const mounted = await mountYandexPayInfoWidget(container, config)
            this.isLoading = false
            this.shouldRender = mounted
        },
        destroyWidget() {
            const container = this.$refs.widgetContainer
            if (container) {
                unmountYandexPayInfoWidget(container)
            }
        },
    },
}
</script>

<style scoped>
.yandex-pay-split-widget {
    width: 100%;
    min-height: 76px;
    margin: 12px 0;
}

.yandex-pay-split-widget__skeleton {
    width: 100%;
    min-height: 76px;
    border-radius: 20px;
    background: linear-gradient(90deg, #f3f4f6 25%, #eceff3 37%, #f3f4f6 63%);
    background-size: 400% 100%;
    animation: yandex-pay-split-widget-skeleton 1.2s ease infinite;
}

.yandex-pay-split-widget__mount {
    width: 100%;
}

.yandex-pay-split-widget__mount--hidden {
    display: none;
}

.yandex-pay-split-widget__mount :deep(.ya-pay-widget) {
    width: 100% !important;
}

@keyframes yandex-pay-split-widget-skeleton {
    0% {
        background-position: 100% 0;
    }

    100% {
        background-position: 0 0;
    }
}
</style>
